/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

function SEO({ description, lang, meta, title, ogimg, link}) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={`%s`}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:site_name`,
          content: `Merit Mile`,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: `og:image`,
          content: ogimg,
        },
        {
          property: `og:url`,
          content: link,
        },
        {
          name: `twitter:card`,
          content: `summary_large_image`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata.author,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
        {
          property: `twitter:image`,
          content: ogimg,
        },
      ].concat(meta)}
    >
      <script src={`https://www.google.com/recaptcha/api.js?r=${Math.random()}`} async defer></script>
      {/* <script type="application/ld+json">{JSON.stringify({})}</script> */}
      <script type="application/ld+json">{`
        {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebSite",
              "@id": "https://www.meritmile.com/#/schema/WebSite",
              "url": "https://www.meritmile.com/",
              "name": "Merit Mile",
              "description": "Merit Mile",
              "inLanguage": "en-US",
              "potentialAction": {
                "@type": "SearchAction",
                "target": {
                  "@type": "EntryPoint",
                  "urlTemplate": "https://www.meritmile.com/?s=/{search_term_string}/"
                },
                "query-input": "required name=search_term_string"
              },
              "publisher": {
                "@id": "https://www.meritmile.com/#/schema/Organization"
              }
            },
            {
              "@type": "WebPage",
              "@id": "https://www.meritmile.com/",
              "url": "https://www.meritmile.com/",
              "name": "Merit Mile | Advertising, PR & Interactive Agency | Boca Raton, FL",
              "description": "Merit Mile is an award-winning Advertising, PR and Interactive agency based in Boca Raton, FL and serving clients globally. Contact us today to get started.",
              "inLanguage": "en-US",
              "isPartOf": {
                "@id": "https://www.meritmile.comm/#/schema/WebSite"
              },
              "breadcrumb": {
                "@type": "BreadcrumbList",
                "@id": "https://www.meritmile.com/#/schema/BreadcrumbList",
                "itemListElement": {
                  "@type": "ListItem",
                  "position": 1,
                  "name": "Merit Mile"
                }
              },
              "potentialAction": {
                "@type": "ReadAction",
                "target": "https://www.meritmile.com/"
              },
              "about": {
                "@id": "https://www.meritmile.com/#/schema/Organization"
              }
            },
            {
              "@type": "Organization",
              "@id": "https://www.meritmile.com/#/schema/Organization",
              "name": "Merit Mile, LLC.",
              "url": "https://www.meritmile.com/"
            }
          ]
        }
    `}</script>
    </Helmet>
  )
}

SEO.defaultProps = {
  lang: `en-US`,
  meta: [],
  description: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default SEO
